// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleContainer {
  display: flex;
  gap: 5px;
}
.toggleContainer .toggle {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.toggleContainer .toggle input[type=checkbox] {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggleContainer .toggle .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 25px;
  width: 50px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}
.toggleContainer .toggle input:checked + .slider {
  background-color: #2196f3;
}
.toggleContainer .toggle input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
.toggleContainer .toggle input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.toggleContainer .toggle .slider:before {
  position: absolute;
  content: "";
  height: 17px;
  width: 17px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}
.toggleContainer .text {
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/ToggleButton/ToggleButton.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,QAAA;AACJ;AAAI;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAER;AAAQ;EACI,UAAA;EACA,QAAA;EACA,SAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AAAQ;EACI,yBAAA;AAEZ;AAAQ;EACI,2BAAA;AAEZ;AAAQ;EACI,mCAAA;EACA,+BAAA;EACA,2BAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AACI;EACI,eAAA;AACR","sourcesContent":[".toggleContainer {\n    display: flex;\n    gap: 5px;\n    .toggle {\n        position: relative;\n        display: inline-block;\n        width: 60px;\n        height: 34px;\n\n        input[type=\"checkbox\"] {\n            opacity: 0;\n            width: 0;\n            height: 0;\n        }\n        .slider {\n            position: absolute;\n            cursor: pointer;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            height: 25px;\n            width: 50px;\n            background-color: #ccc;\n            -webkit-transition: 0.4s;\n            transition: 0.4s;\n            border-radius: 34px;\n        }\n        input:checked + .slider {\n            background-color: #2196f3;\n        }\n        input:focus + .slider {\n            box-shadow: 0 0 1px #2196f3;\n        }\n        input:checked + .slider:before {\n            -webkit-transform: translateX(26px);\n            -ms-transform: translateX(26px);\n            transform: translateX(26px);\n        }\n        .slider:before {\n            position: absolute;\n            content: \"\";\n            height: 17px;\n            width: 17px;\n            left: 4px;\n            bottom: 4px;\n            background-color: white;\n            -webkit-transition: 0.4s;\n            transition: 0.4s;\n            border-radius: 34px;\n        }\n    }\n    .text {\n        margin-top: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
